import type { FC, ReactNode } from 'react'

import { CarFront } from 'lucide-react'
import { cn } from '@/lib/utils'
import { usePhotoUrl } from '@/hooks/use-photo'

interface VehiclePhotoProps {
    photo: string | null | undefined
    alt: string
    className?: string
    iconClassName?: string
}

export const VehiclePhoto: FC<VehiclePhotoProps> = ({
    photo,
    alt,
    className,
    iconClassName
}): ReactNode => {
    const url = usePhotoUrl(photo)

    return (
        <div className={cn('relative shrink-0 overflow-hidden bg-linear-to-br from-slate-100 to-slate-200', className)}>
            {url
                ? (
                    <img
                        src={url}
                        alt={alt}
                        loading='lazy'
                        decoding='async'
                        className='absolute inset-0 size-full object-cover'
                    />
                )
                : (
                    <div className='absolute inset-0 grid place-items-center text-slate-400'>
                        <CarFront className={cn('size-7', iconClassName)} aria-hidden='true' />
                        <span className='sr-only'>No photo</span>
                    </div>
                )}
        </div>
    )
}
